// extracted by mini-css-extract-plugin
export default {"component":"AchievementsHeader_component__9OA6v"};